import { IRouteLink } from '@api/types/ui';

export const GAMES_LINKS: IRouteLink[] = [
    {
        name: 'Coinflip',
        path: '/games/coinflip',
    },
    {
        name: 'Jackpot',
        path: '/games/jackpot',
    },
];

export const EXTRAS_LINKS: IRouteLink[] = [
    {
        name: 'Help Center',
        path: '/help',
    },
    {
        name: 'Terms of Service',
        path: '/terms',
    },
    {
        name: 'Provably Fair',
        path: '/provably-fair',
    },
    {
        name: 'Affiliates',
        path: '/',
    },
];

export const BREAKPOINTS = {
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
    XXL: 1400,
    _2XXL: 1600,
    _3XXL: 1800,
};
